export const fetchPrivateSalesFiltersUrl = `/privateparkings/list/filters`;
export const fetchPrivateSalesListUrl = `/privateparkings/list`;
export const fetchPrivateSalesInfoUrl = `/privateparkings`;
export const fetchPrivateSalesExportUrl = `/privateparkings/export/all`;
